'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'face-hushed';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e37b';
var svgPathData = ['M48 256a208 208 0 1 0 416 0 208 208 0 1 0 -416 0zm49.4-66.3c-7.5-8.1-7.1-20.7 1-28.3 20.6-19.3 46.8-32.4 75.9-36.2 5.8-.8 11.7-1.2 17.7-1.2 11 0 20 9 20 20s-9 20-20 20c-4.2 0-8.4 .3-12.5 .8-20.3 2.7-38.9 11.9-53.8 25.8-8.1 7.5-20.7 7.1-28.3-1zM208 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 128a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-4-240c0-11 9-20 20-20 6 0 11.9 .4 17.7 1.2 29.1 3.8 55.3 17 75.9 36.2 8.1 7.5 8.5 20.2 1 28.3s-20.2 8.5-28.3 1c-14.9-13.9-33.5-23.1-53.8-25.8-4.1-.5-8.3-.8-12.5-.8-11 0-20-9-20-20zm68 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M464 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm176-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179.5 164.8c-20.3 2.7-38.9 11.9-53.8 25.8-8.1 7.5-20.7 7.1-28.3-1s-7.1-20.7 1-28.3c20.6-19.3 46.8-32.4 75.9-36.2 5.8-.8 11.7-1.2 17.7-1.2 11 0 20 9 20 20s-9 20-20 20c-4.2 0-8.4 .3-12.5 .8zM320 164c-11 0-20-9-20-20s9-20 20-20c6 0 11.9 .4 17.7 1.2 29.1 3.8 55.3 17 75.9 36.2 8.1 7.5 8.5 20.2 1 28.3s-20.2 8.5-28.3 1c-14.9-13.9-33.5-23.1-53.8-25.8-4.1-.5-8.3-.8-12.5-.8zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceHushed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;